import * as vehicleTypes from 'vdp-used/actions/vdpUsedActionTypes.js';
import { PurchaseMethods, Vehicle } from '@sm360/widget-commons-vehicle';

const { PurchaseMethodsActionsTypes } = PurchaseMethods;
const { VehicleService } = Vehicle;

export default function vehiclesReducer(state = [], action) {
    switch (action.type) {
        case vehicleTypes.ADD_VEHICLES:
            return action.vehicles;

        case vehicleTypes.SET_VEHICLES:
            return action.vehicles;

        case PurchaseMethodsActionsTypes.SET_CASH_DOWN:
            return state.map((vehicle) => VehicleService.setCashDown(vehicle, action.cashDown));

        case PurchaseMethodsActionsTypes.SELECT_TERM:
            return state.map((vehicle) => VehicleService.setBestPaymentTerm(vehicle, action.term));

        case PurchaseMethodsActionsTypes.SELECT_PAYMENT_FREQUENCY:
            return state.map((vehicle) =>
                VehicleService.selectPaymentFrequency(vehicle, action.paymentFrequency.value)
            );

        default:
            return state;
    }
}
